@let readOnly = $readOnly();

<form [formGroup]="formGroup">
  <div class="x-card x-card_size_m x-white card-shadow">
    <p class="x-island-header">
      {{ 'request_form.common.main.title' | translate }}
    </p>

    <div class="x-input-label">№ проекта</div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.ProjectNumber"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>

    @if (permissionService.canLogistViewScheduleOwners$ | async) {
      <div class="x-input-label text-red-500">
        {{ 'request_form.common.main.counterparty_owner' | translate }}
      </div>
      @let request = requestService.$request();
      <div class="text-sm pl-3">
        {{
          request.counterpartyOwnerId.shortName ||
            request.counterpartyOwnerId.name ||
            'request_form.common.main.error_counterparty_owner_not_defined'
            | translate
        }}
      </div>
    }
    @if (
      (permissionService.canViewRequestExecutor$ | async) &&
      !$hideExecutorBlock()
    ) {
      <div class="x-input-label">
        {{ 'request_form.common.main.contractor_counterparty' | translate }}
      </div>
      <x-form-picker
        [formControlName]="FormFields.ContractorCounterpartyId"
        [readOnly]="readOnly"
        xAttachExecutors
      ></x-form-picker>
      @if (contractorCounterpartyIdField.value) {
        <div class="x-input-label">
          {{
            'request_form.common.main.contractor_counterparty_subdivision'
              | translate
          }}
        </div>
        <x-form-picker
          [formControlName]="FormFields.ContractorCounterpartySubdivisionId"
          [contractorId]="contractorCounterpartyIdField.value.id"
          [readOnly]="readOnly"
          xAttachSubdivisions
        ></x-form-picker>
      }
      @if (contractorCounterpartySubdivisionIdField.value) {
        <div class="x-input-label">
          {{ 'request_form.common.main.install_zone' | translate }}
        </div>
        <x-form-picker
          [formControlName]="FormFields.InstallZoneId"
          [ownerId]="$request().counterpartyOwnerId.id"
          [contractorId]="contractorCounterpartyIdField.value!.id"
          [contractorSubdivisionId]="
            contractorCounterpartySubdivisionIdField.value.id
          "
          [readOnly]="readOnly"
          xAttachZones
        ></x-form-picker>
        @if (installZoneIdField.value?.comment) {
          <div class="text-sky-500 text-xs mt-1">
            {{ installZoneIdField.value?.comment }}
          </div>
        }
        @if (installZoneIdField.value) {
          <div class="x-input-label">
            {{ 'request_form.common.main.install_price' | translate }}
          </div>
          <tui-textfield tuiTextfieldSize="m">
            <input
              [formControlName]="FormFields.InstallPrice"
              tuiInput
              [readOnly]="readOnly"
            />
          </tui-textfield>
        }
        <div class="x-input-label">
          {{ 'request_form.common.main.installer' | translate }}
        </div>
        <x-form-picker
          [formControlName]="FormFields.InstallerId"
          [stringifyFn]="installersStringifyFn"
          [contractorId]="contractorCounterpartyIdField.value!.id"
          [contractorSubdivisionId]="
            contractorCounterpartySubdivisionIdField.value.id
          "
          [readOnly]="readOnly"
          xAttachInstallers
        ></x-form-picker>
      }
    }
  </div>
</form>
